export default "__VITE_ASSET__lLXxF8dB__"